import React from "react";
import { ArrowIcon } from "./Icons";

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SidebarArrow: React.FC<Props> = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <button
      type="button"
      aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
      aria-expanded={sidebarOpen}
      className="rounded-full fixed top-28 z-20 w-8 h-8 flex justify-center items-center cursor-pointer bg-background sidebar-backdrop border-2 border-border neo-shadow hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]"
      style={{ left: sidebarOpen ? "min(484px, calc(100vw - 40px))" : "6px" }}
      onClick={() => {
        setSidebarOpen(!sidebarOpen);
      }}
    >
      <ArrowIcon
        className={`text-foreground ${sidebarOpen ? "" : "rotate-180"}`}
      />
    </button>
  );
};

export default SidebarArrow;
